module.exports = __webpack_public_path__ + "media/site/images/icons/design-icon-f9105ea51f134d57518f6e3a5f6f403d.svg";